<div class="page">
  <div class="header">
    <button mat-icon-button type="button" (click)="cerrar()">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div>
      <h1>Historia clínica</h1>
      <p>
        {{ data.paciente.nombre }} {{ data.paciente.apellido }} {{ data.paciente.segundoApellido }}
      </p>
    </div>
  </div>

  <form [formGroup]="form" class="body">
    @for (grupo of grupos; track grupo.titulo) {
      <div class="grupo-card">
        <div class="grupo-header">
          <!-- <mat-icon class="material-symbols-outlined">{{ grupo.icono }}</mat-icon> -->
          <strong>{{ grupo.titulo }}</strong>
        </div>

        <div class="historia-grid">
          @for (campo of grupo.campos; track campo.control) {
            <mat-form-field appearance="outline">
              <mat-label>{{ campo.etiqueta }}</mat-label>

              <textarea
                matInput
                rows="3"
                maxlength="200"
                [id]="'historia-' + campo.control"
                [placeholder]="campo.placeholder ?? campo.etiqueta"
                [formControlName]="campo.control"
              ></textarea>

              <mat-hint align="end">{{ form.get(campo.control)?.value?.length || 0 }}/200</mat-hint>

              @if (form.get(campo.control)?.hasError('required')) {
                <mat-error>Este campo es obligatorio.</mat-error>
              }
            </mat-form-field>
          }
        </div>
      </div>
    }
  </form>

  @if (editable) {
    <div class="acciones">
      <button
        mat-flat-button
        type="button"
        class="add-boton"
        [disabled]="guardando"
        (click)="guardar()"
      >
        {{ guardando ? 'Guardando...' : 'Guardar' }}
        <mat-icon>save</mat-icon>
      </button>
    </div>
  } @else {
    <p class="nota">La consulta ya no está activa: la historia clínica es de solo lectura.</p>
  }
</div>
